/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PathologyApiConfiguration, PathologyApiConfigurationParams } from './pathology-api-configuration';

import { PATHInsuranceService } from './services/path-insurance.service';
import { PATHPathologyService } from './services/path-pathology.service';
import { PATHQuestionareService } from './services/path-questionare.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PATHInsuranceService,
    PATHPathologyService,
    PATHQuestionareService,
    PathologyApiConfiguration
  ],
})
export class PathologyModule {
  static forRoot(params: PathologyApiConfigurationParams): ModuleWithProviders<PathologyModule> {
    return {
      ngModule: PathologyModule,
      providers: [
        {
          provide: PathologyApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PathologyModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PathologyModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
